<div>
  <div class="add-title">
    <h2 class="primary">Add device</h2>
  </div>
  <div>
    <form [formGroup]="addThingsForm" (change)="formChanged()">


      <mat-grid-list cols="1" rowHeight="85px" (window:resize)="onResize($event)">



        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="example-full-width">
              <input matInput placeholder="SERIAL NUMBER" value={{snr}} [formControl]="snrControl">
            </mat-form-field>
          </div>
        </mat-grid-tile>

        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field>
              <input matInput placeholder="CPU ID" value={{cpuId}} [formControl]="cpuControl">
            </mat-form-field>
          </div>
        </mat-grid-tile>

        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field>
              <input class="form-control" matInput placeholder="ETHERNET MAC" [formControl]="macEthCntrl">
            </mat-form-field>
          </div>
        </mat-grid-tile>

      </mat-grid-list>




    </form>

    <div class="profile-footer">
      <button mat-raised-button class="btn-block change-pw-button" (click)="commissionDevice()">Add</button>

      <button mat-raised-button class="btn-block change-pw-button" (click)="openDialog()">Cancel</button>
    </div>
  </div>
</div>
